import React, { Component } from 'react';
import Image from 'next/image';
import { Col, Row } from 'antd';

import jingpinlan from '../public/images/facebook_jingpin.png';
import zhaopian from '../public/images/facebook_zhaopian.png';
import huandengpian from '../public/images/facebook_huandeng.png';
import lunbo from '../public/images/facebook_lunbo.png';
import shipin from '../public/images/facebook_shipin.png';
import yiren from '../public/images/facebook_yiren.png';
import hudong from '../public/images/facebook_hudong.png';
import zhenshi from '../public/images/facebook_zhenshi.png';
import fugai from '../public/images/facebook_fugai.png';

const fbAdsForms = [
  { image: jingpinlan, title: '精品栏广告' },
  { image: zhaopian, title: '照片广告' },
  { image: huandengpian, title: '幻灯片广告' },
  { image: lunbo, title: '轮播广告' },
  { image: shipin, title: '视频广告' },
];

const fbAdvantages = [
  { image: yiren, title: '以人为本' },
  { image: hudong, title: '互动程度高' },
  { image: zhenshi, title: '真实身份' },
  { image: fugai, title: '覆盖范围广' },
];

class Facebook extends Component {
  render() {
    return (
      <div id="Facebook">
        <div className="banner">
          <Image
            src={require('../public/images/banner-5.jpg').default}
            alt="fb-banner"
            layout="responsive"
          />
        </div>

        <div className="introduce">
          <div className="bb">
            <div className="facebook-summary">
              <p>
                Facebook是全球最大的社交网络服务网站，亦是全球最佳的精准营销平台。数百万的企业已经通过Facebook把业务推广到了全世界，
                基于真实用户数据的核心定位可以精准圈定潜在目标用户，多样化、全方位的广告投放，准确传递产品信息。
              </p>
            </div>

            <div className="facebook-products">
              <div className="header">
                <div className="inner-header-3">
                  <h3>为什么选择Facebook？</h3>
                  <p>Why choose Facebook</p>
                </div>

                <p className="des">
                  Facebook拥有一系列强大的平台和移动应用，能够提供全方位的营销解决方案，帮助商家与来自全球的用户紧密相连。
                </p>
              </div>

              <div className="inner-content">
                <ul className="row">
                  <li className="col">
                    <Image
                      src={
                        require('../public/images/facebook-icon.png').default
                      }
                      alt="Facebook"
                    />
                    <p>Facebook</p>
                    <p className="yellow-text">
                      <span className="big-num">22</span>亿用户
                    </p>
                  </li>
                  <li className="col">
                    <Image
                      src={
                        require('../public/images/whatsapp-icon.png').default
                      }
                      alt="WhatsApp"
                    />
                    <p>WhatsApp</p>
                    <p className="yellow-text">
                      <span className="big-num">15</span>亿用户
                    </p>
                  </li>
                  <li className="col">
                    <Image
                      src={
                        require('../public/images/facebook-messenger-3.png')
                          .default
                      }
                      alt="Messenger"
                    />
                    <p>Messenger</p>
                    <p className="yellow-text">
                      <span className="big-num">13</span>亿用户
                    </p>
                  </li>
                  <li className="col">
                    <Image
                      src={
                        require('../public/images/instagram-2-1.png').default
                      }
                      alt="Instagram"
                    />
                    <p>Instagram</p>
                    <p className="yellow-text">
                      <span className="big-num">10</span>亿用户
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="facebook-solutions bb">
          <div className="header">
            <div className="inner-header-3">
              <h3>Facebook营销解决方案</h3>
              <p>Facebook marketing solutions</p>
            </div>
          </div>

          <div className="inner-content">
            <Row justify="space-between" align="middle">
              <Col span={7}>
                <Image
                  src={require('../public/images/fb-左.png').default}
                  alt="Facebook-营销解决方案"
                />
              </Col>
              <Col span={10}>
                <Image
                  src={require('../public/images/facebook-s.png').default}
                  alt="Facebook-营销解决方案"
                />
              </Col>
              <Col span={7}>
                <Image
                  src={require('../public/images/fb-右.png').default}
                  alt="Facebook-营销解决方案"
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="facebook-ads">
          <div className="bb">
            <div className="header">
              <div className="inner-header-3">
                <h3>Facebook多种广告形式</h3>
                <p>Facebook&apos;s multiple forms of advertising</p>
              </div>
            </div>

            <div className="inner-content">
              <ul className="row">
                {fbAdsForms.map((item, index) => {
                  return (
                    <li className="col" key={index}>
                      <Image src={item.image} alt={item.title} />
                      <p>{item.title}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="facebook-others">
          <div className="bb">
            <div className="header">
              <div className="inner-header-3">
                <h3>
                  在Facebook发布广告可轻松找到合适得受众、吸引受众关注并收获成效
                </h3>
              </div>
            </div>

            <div className="inner-content">
              <ul className="row">
                {fbAdvantages.map((item, index) => {
                  return (
                    <li className="col" key={index}>
                      <Image src={item.image} alt={item.title} />
                      <p className="other-title">{item.title}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Facebook;
